import SendIcon from "@material-ui/icons/Send";
import {Button, ButtonProps, useListContext} from "react-admin";
import {useMemo, useState} from "react";
import {
    Dialog,
    DialogContent,
    DialogTitle,
    DialogActions,
    Typography,
    Box,
    TextField,
    Divider, Checkbox, FormControlLabel,
} from "@material-ui/core";
import {makeStyles} from "@material-ui/core/styles";
import {client} from "../../dataProvider";
import {ContextEmail} from "./ContextEmail";
import {getUser} from "../../authProvider";

const useStyles = makeStyles((theme) => ({
    dialogPaper: {
        minWidth: "600px",
        maxWidth: "800px",
    },
    formField: {
        marginBottom: theme.spacing(2),
    },
}));


export const BulkActionSendDeliveryEmail = (props: ButtonProps) => {
    const classes = useStyles();
    const [open, setOpen] = useState(false);
    const {selectedIds, refetch, data} = useListContext();
    const [forceSend, setForceSend] = useState(false);
    const [reason, setReason] = useState("");
    const [notes, setNotes] = useState("");
    const user = getUser();
    const signatory = [user?.first_name, user?.last_name].filter(Boolean).join(" ") || "Supersonica srl";

    const selectedDeliveries = useMemo(() => {
        const records = Array.isArray(data) ? data : Object.values(data || {});
        return records.filter((record: any) => selectedIds.includes(record.id));
    }, [data, selectedIds]);

    const selectedStatusValue = (field: string) => {
        const values = Array.from(new Set(selectedDeliveries
            .map((record: any) => record[field])
            .filter((value: any) => Boolean(value))));
        if (values.length === 0) return "-";
        if (values.length === 1) return values[0] as string;
        return "Valore diverso per ciascuna missione selezionata";
    };

    const statusReason = selectedStatusValue("status_reason");
    const statusNotes = selectedStatusValue("status_notes");
    const canPrefillReason = statusReason !== "-" && !statusReason.startsWith("Valore diverso");
    const canPrefillNotes = statusNotes !== "-" && !statusNotes.startsWith("Valore diverso");

    const handleSend = async () => {
        await client("deliveries/send_email_deliveries", {
            method: "POST",
            data: {
                reason,
                notes,
                force_send: forceSend,
                ids: selectedIds
            }
        }).then((response) => {
            let message = "Email inviata"
            if(response["deliveries_already_sent"].length > 0){
                message += ` ,attenzione però le missioni con id ${response["deliveries_already_sent"]} sono state già notificate, contatta l'assistenza per sbloccare l'invio delle email`
            }
            if(response["client_without_email"].length > 0){
                message += ` ,i clienti delle missioni con id ${response["client_without_email"]} non hanno un indirizzo email`
            }
            alert(message);

            refetch();
        }).catch((error) => {
            alert("Errore durante l'invio dell'email");
            console.log(error);
        })
        setOpen(false);
    };

    return (
        <>
            <Button
                {...props}
                onClick={() => {
                    setReason(canPrefillReason ? statusReason : "");
                    setNotes(canPrefillNotes ? statusNotes : "");
                    setOpen(true);
                }}
                label="Invia email"
            >
                <SendIcon/>
            </Button>
            <Dialog
                open={open}
                onClose={() => setOpen(false)}
                classes={{paper: classes.dialogPaper}}
                maxWidth="md"
            >
                <DialogTitle>Invia email al cliente</DialogTitle>
                <DialogContent>
                    <Box className={classes.formField}>
                        <TextField
                            fullWidth
                            label="Motivo"
                            value={reason}
                            onChange={(e) => setReason(e.target.value)}
                            variant="outlined"
                            size="small"
                        />
                    </Box>
                    <Box className={classes.formField}>
                        <TextField
                            fullWidth
                            label="Note da inserire nell'email"
                            value={notes}
                            onChange={(e) => setNotes(e.target.value)}
                            variant="outlined"
                            size="small"
                            multiline
                            minRows={3}
                        />
                    </Box>
                    <Box className={classes.formField}>
                        <FormControlLabel
                            control={
                                <Checkbox
                                    checked={forceSend}
                                    onChange={() => setForceSend(!forceSend)}
                                    name="checkedF"
                                />
                            }
                            label="Forza invio email"
                        />
                    </Box>

                    <Divider style={{margin: "20px 0"}}/>

                    <Typography variant="subtitle2" gutterBottom>
                        Anteprima email:
                    </Typography>

                    <ContextEmail
                        notes={notes || statusNotes}
                        reason={reason || statusReason}
                        signatory={signatory}
                    />
                </DialogContent>
                <DialogActions>
                    <Button label="Annulla" onClick={() => setOpen(false)}/>
                    <Button
                        label="Invia"
                        onClick={handleSend}
                        variant="contained"
                        style={{backgroundColor: "#1976d2", color: "white"}}
                    >
                        <SendIcon style={{marginRight: "8px"}}/>
                    </Button>
                </DialogActions>
            </Dialog>
        </>
    );
};
